export interface TranslationParams {
  [key: string]: string | number;
}

export interface Translations {
  [key: string]: {
    [lang: string]: string;
  };
}


export const translations: Translations = {
  // User actions and voting
  "userVotes": {
    "es-AR": "Tus fotos",
    "es-MX": "Tus fotos",
    "en-US": "Your photos"
  },
  "voteReceived": {
    "es-AR": "like",
    "es-MX": "like",
    "en-US": "like"
  },
  "votesReceived": {
    "es-AR": "likes",
    "es-MX": "likes",
    "en-US": "likes"
  },
  "noPhotosVotedYet": {
    "es-AR": "No hay likes aún",
    "es-MX": "No hay likes aún",
    "en-US": "No likes yet"
  },
  "registeredUser": {
    "es-AR": "Registrado",
    "es-MX": "Registrado",
    "en-US": "Registered user"
  },
  "registeredUsers": {
    "es-AR": "Registrados",
    "es-MX": "Registrados",
    "en-US": "Registered users"
  },

  // Navigation and buttons
  "uploadPhotos": {
    "es-AR": "Subir fotos",
    "es-MX": "Subir fotos",
    "en-US": "Upload photos"
  },
  "viewAlbum": {
    "es-AR": "Álbum Digital",
    "es-MX": "Álbum Digital",
    "en-US": "Photo Album"
  },
  "viewGuestbook": {
    "es-AR": "Libro de Visitas",
    "es-MX": "Libro de Visita",
    "en-US": "Guestbook"
  },
  "invitation": {
    "es-AR": "Invitación",
    "es-MX": "Invitación",
    "en-US": "Invitation"
  },
  "access": {
    "es-AR": "Acceder",
    "es-MX": "Acceder",
    "en-US": "Access"
  },
  "loading": {
    "es-AR": "Cargando...",
    "es-MX": "Cargando...",
    "en-US": "Loading..."
  },

  // Album and media
  "digitalAlbum": {
    "es-AR": "Álbum Digital",
    "es-MX": "Álbum Digital",
    "en-US": "Digital Album"
  },
  "photo": {
    "es-AR": "foto",
    "es-MX": "foto",
    "en-US": "photo"
  },
  "photos": {
    "es-AR": "fotos",
    "es-MX": "fotos",
    "en-US": "photos"
  },
  "video": {
    "es-AR": "video",
    "es-MX": "video",
    "en-US": "video"
  },
  "videos": {
    "es-AR": "videos",
    "es-MX": "videos",
    "en-US": "videos"
  },

  // Filters and sorting
  "filterByUser": {
    "es-AR": "Filtrar por usuario",
    "es-MX": "Filtrar por usuario",
    "en-US": "Filter by user"
  },
  "allUsers": {
    "es-AR": "Todos los usuarios",
    "es-MX": "Todos los usuarios",
    "en-US": "All users"
  },
  "sortBy": {
    "es-AR": "Ordenar por",
    "es-MX": "Ordenar por",
    "en-US": "Sort by"
  },
  "newest": {
    "es-AR": "Más recientes arriba",
    "es-MX": "Más recientes arriba",
    "en-US": "Newest first"
  },
  "oldest": {
    "es-AR": "Más antiguos arriba",
    "es-MX": "Más antiguos arriba",
    "en-US": "Oldest first"
  },

  // Error messages and status
  "errorLoadingContent": {
    "es-AR": "Error al cargar el contenido",
    "es-MX": "Error al cargar el contenido",
    "en-US": "Error loading content"
  },
  "noPhotosUploaded": {
    "es-AR": "Aún no hay fotos",
    "es-MX": "Aún no hay fotos",
    "en-US": "No photos uploaded yet"
  },
  "downloadingImage": {
    "es-AR": "Descargando imagen...",
    "es-MX": "Descargando imagen...",
    "en-US": "Downloading image..."
  },
  "imageDownloaded": {
    "es-AR": "Imagen descargada",
    "es-MX": "Imagen descargada",
    "en-US": "Image downloaded"
  },

  // Time and dates
  "today": {
    "es-AR": "Hoy",
    "es-MX": "Hoy",
    "en-US": "Today"
  },
  "yesterday": {
    "es-AR": "Ayer",
    "es-MX": "Ayer",
    "en-US": "Yesterday"
  },

  // Stats and counts with interpolation
  "totalPhotosCount": {
    "es-AR": "Tenés {count} foto{s}",
    "es-MX": "Tienes {count} foto{s}",
    "en-US": "You have {count} photo{s}"
  },
  "userLikesCount": {
    "es-AR": "{count} {votes} en total",
    "es-MX": "{count} {votes} en total",
    "en-US": "{count} {votes} in total"
  },
  "addDescription": {
    "es-AR": "Agregar descripción...",
    "es-MX": "Agregar descripción...",
    "en-US": "Add description..."
  },
  "descriptionLabel": {
    "es-AR": "Descripción",
    "es-MX": "Descripción",
    "en-US": "Description"
  },
  "more": {
    "es-AR": "más",
    "es-MX": "más",
    "en-US": "more"
  },
  "less": {
    "es-AR": "menos",
    "es-MX": "menos",
    "en-US": "less"
  },
  "filter": {
    "es-AR": "Filtrar",
    "es-MX": "Filtrar",
    "en-US": "Filter"
  },
  "sort": {
    "es-AR": "Ordenar",
    "es-MX": "Ordenar",
    "en-US": "Sort"
  }
};

// Additional translations for the new strings
const additionalTranslations = {
  "noPhotosWithFilters": {
    "es-AR": "No hay fotos con estos filtros",
    "es-MX": "No hay fotos con estos filtros",
    "en-US": "No photos with these filters"
  },
  "tryChangingFilters": {
    "es-AR": "Intentá cambiar los filtros para ver más fotos",
    "es-MX": "Intenta cambiar los filtros para ver más fotos",
    "en-US": "Try changing the filters to see more photos"
  },
  "photosWillAppearHere": {
    "es-AR": "Las fotos van a aparecer acá cuando los invitados las suban",
    "es-MX": "Las fotos aparecerán aquí cuando los invitados las suban",
    "en-US": "Photos will appear here when guests upload them"
  },
  "uploadsComingSoon": {
    "es-AR": "Pronto se podrá subir",
    "es-MX": "Pronto se podrá subir",
    "en-US": "Uploads coming soon"
  },
  "uploadFirstPhoto": {
    "es-AR": "Subí la primera foto",
    "es-MX": "Sube la primera foto",
    "en-US": "Upload the first photo"
  },

  // Admin panel and widgets
  "adminPanelTitle": {
    "es-AR": "Panel de Anfitrión",
    "es-MX": "Panel de Anfitrión",
    "en-US": "Control Center"
  },
  "adminMetaTitle": {
    "es-AR": "Panel de Anfitrión - Admin",
    "es-MX": "Panel de Anfitrión - Admin",
    "en-US": "Admin panel"
  },
  "usersTitle": {
    "es-AR": "Usuarios",
    "es-MX": "Usuarios",
    "en-US": "Users"
  },
  "activeNow": {
    "es-AR": "Activo{s} ahora",
    "es-MX": "Activo{s} ahora",
    "en-US": "Active now"
  },
  "photosTitle": {
    "es-AR": "Fotos",
    "es-MX": "Fotos",
    "en-US": "Uploaded photos"
  },
  "uploadedShort": {
    "es-AR": "Subidas",
    "es-MX": "Subidas",
    "en-US": "Uploaded"
  },
  "votedShort": {
    "es-AR": "Con likes",
    "es-MX": "Con likes",
    "en-US": "Liked"
  },
  "moderatedShort": {
    "es-AR": "Ocultas",
    "es-MX": "Ocultas",
    "en-US": "Hidden"
  },
  "liveGallery": {
    "es-AR": "Galería en Vivo",
    "es-MX": "Galería en Vivo",
    "en-US": "Live Gallery"
  },
  "viewLarge": {
    "es-AR": "Acceder",
    "es-MX": "Acceder",
    "en-US": "Open"
  },
  "rankingTitle": {
    "es-AR": "Ranking",
    "es-MX": "Ranking",
    "en-US": "Leaderboard"
  },
  "quickActions": {
    "es-AR": "Accesos Rápidos",
    "es-MX": "Accesos Rápidos",
    "en-US": "Quick Actions"
  },
  "manageUsers": {
    "es-AR": "Gestionar Usuarios",
    "es-MX": "Gestionar Usuarios",
    "en-US": "Manage Users"
  },
  "viewGallery": {
    "es-AR": "Ver Álbum Digital",
    "es-MX": "Ver Álbum Digital",
    "en-US": "View Album"
  },
  "viewGuestbook": {
    "es-AR": "Libro de Visitas",
    "es-MX": "Libro de Visitas",
    "en-US": "Guestbook"
  },
  "managePhotos": {
    "es-AR": "Gestionar Fotos",
    "es-MX": "Gestionar Fotos",
    "en-US": "Manage Photos"
  },
  "manageThemes": {
    "es-AR": "Diseño",
    "es-MX": "Diseño",
    "en-US": "Design Studio"
  },

  // Generic toasts / clipboard actions
  "copied": {
    "es-AR": "Listo",
    "es-MX": "Listo",
    "en-US": "Done!"
  },
  "idCopiedToClipboard": {
    "es-AR": "ID copiado al portapapeles",
    "es-MX": "ID copiado al portapapeles",
    "en-US": "ID copied to clipboard"
  },
  "error": {
    "es-AR": "Error",
    "es-MX": "Error",
    "en-US": "Error"
  },
  "copyToClipboardFailed": {
    "es-AR": "No se pudo copiar al portapapeles",
    "es-MX": "No se pudo copiar al portapapeles",
    "en-US": "Failed to copy to clipboard"
  },

  // Admin Users page
  "adminUsersMetaTitle": {
    "es-AR": "Gestión de Usuarios - Admin",
    "es-MX": "Gestión de Usuarios - Admin",
    "en-US": "User Management - Admin"
  },
  "loadingUsers": {
    "es-AR": "Cargando usuarios...",
    "es-MX": "Cargando usuarios...",
    "en-US": "Loading users..."
  },
  "userHeader": {
    "es-AR": "Usuario",
    "es-MX": "Usuario",
    "en-US": "User"
  },
  "lastActivity": {
    "es-AR": "Última actividad",
    "es-MX": "Última actividad",
    "en-US": "Last activity"
  },
  "activeHeader": {
    "es-AR": "Activo",
    "es-MX": "Activo",
    "en-US": "Active"
  },
  "roleHeader": {
    "es-AR": "Rol",
    "es-MX": "Rol",
    "en-US": "Role"
  },
  "blockHeader": {
    "es-AR": "Bloquear",
    "es-MX": "Bloquear",
    "en-US": "Block"
  },
  "deleteHeader": {
    "es-AR": "Eliminar",
    "es-MX": "Eliminar",
    "en-US": "Delete"
  },
  "blockTooltip": {
    "es-AR": "El usuario no podrá acceder al sistema y sus fotos se ocultarán hasta ser desbloqueado.",
    "es-MX": "El usuario no podrá acceder al sistema y sus fotos se ocultarán hasta ser desbloqueado.",
    "en-US": "The user won’t be able to access the system and their photos will be hidden until unblocked."
  },
  "deleteTooltip": {
    "es-AR": "Eliminar el registro del usuario. Nota: el usuario puede volver a registrarse.",
    "es-MX": "Eliminar el registro del usuario. Nota: el usuario puede volver a registrarse.",
    "en-US": "Delete the user record. Note: the user can register again."
  },
  "activeStatus": {
    "es-AR": "Activo",
    "es-MX": "Activo",
    "en-US": "Active"
  },
  "inactiveStatus": {
    "es-AR": "Inactivo",
    "es-MX": "Inactivo",
    "en-US": "Inactive"
  },
  "export": {
    "es-AR": "Exportar",
    "es-MX": "Exportar",
    "en-US": "Export"
  },
  "exportAsCsv": {
    "es-AR": "Exportar como .csv",
    "es-MX": "Exportar como .csv",
    "en-US": "Export as .csv"
  },
  "exportAsXlsx": {
    "es-AR": "Exportar como .xlsx",
    "es-MX": "Exportar como .xlsx",
    "en-US": "Export as .xlsx"
  },
  "exportCompleteTitle": {
    "es-AR": "Exportación completa",
    "es-MX": "Exportación completa",
    "en-US": "Export complete"
  },
  "exportCsvDescription": {
    "es-AR": "Usuarios exportados en archivo .csv",
    "es-MX": "Usuarios exportados en archivo .csv",
    "en-US": "Users exported to .csv file"
  },
  "exportXlsxDescription": {
    "es-AR": "Usuarios exportados en archivo .xlsx",
    "es-MX": "Usuarios exportados en archivo .xlsx",
    "en-US": "Users exported to .xlsx file"
  },
  "exportErrorTitle": {
    "es-AR": "Error al exportar",
    "es-MX": "Error al exportar",
    "en-US": "Export error"
  },
  "exportErrorDescription": {
    "es-AR": "No se pudo exportar los usuarios",
    "es-MX": "No se pudo exportar los usuarios",
    "en-US": "Could not export users"
  },
  "userBlockedTitle": {
    "es-AR": "Usuario bloqueado",
    "es-MX": "Usuario bloqueado",
    "en-US": "User blocked"
  },
  "userUnblockedTitle": {
    "es-AR": "Usuario desbloqueado",
    "es-MX": "Usuario desbloqueado",
    "en-US": "User unblocked"
  },
  "userBlockedDescription": {
    "es-AR": "El usuario ha sido bloqueado exitosamente",
    "es-MX": "El usuario ha sido bloqueado exitosamente",
    "en-US": "The user has been blocked successfully"
  },
  "userUnblockedDescription": {
    "es-AR": "El usuario ha sido desbloqueado exitosamente",
    "es-MX": "El usuario ha sido desbloqueado exitosamente",
    "en-US": "The user has been unblocked successfully"
  },
  "couldNotUpdateUserStatus": {
    "es-AR": "No se pudo actualizar el estado del usuario",
    "es-MX": "No se pudo actualizar el estado del usuario",
    "en-US": "Could not update user status"
  },
  "roleUpdatedTitle": {
    "es-AR": "Rol actualizado",
    "es-MX": "Rol actualizado",
    "en-US": "Role updated"
  },
  "roleUpdatedDescription": {
    "es-AR": "El rol del usuario ha sido cambiado a {role}",
    "es-MX": "El rol del usuario ha sido cambiado a {role}",
    "en-US": "The user's role has been changed to {role}"
  },
  "couldNotUpdateUserRole": {
    "es-AR": "No se pudo actualizar el rol del usuario",
    "es-MX": "No se pudo actualizar el rol del usuario",
    "en-US": "Could not update user role"
  },
  "userRemovedTitle": {
    "es-AR": "Usuario eliminado",
    "es-MX": "Usuario eliminado",
    "en-US": "User removed"
  },
  "userRemovedDescription": {
    "es-AR": "{name} ha sido eliminado del álbum exitosamente",
    "es-MX": "{name} ha sido eliminado del álbum exitosamente",
    "en-US": "{name} has been removed from the album successfully"
  },
  "couldNotRemoveUser": {
    "es-AR": "No se pudo eliminar el usuario del álbum",
    "es-MX": "No se pudo eliminar el usuario del álbum",
    "en-US": "Could not remove the user from the album"
  },
  "areYouSureTitle": {
    "es-AR": "¿Estás seguro?",
    "es-MX": "¿Estás seguro?",
    "en-US": "Are you sure?"
  },
  "removeUserDialogDescription": {
    "es-AR": "Esta acción eliminará a {name} del álbum permanentemente.",
    "es-MX": "Esta acción eliminará a {name} del álbum permanentemente.",
    "en-US": "This action will permanently remove {name} from the album."
  },
  "cannotUndo": {
    "es-AR": "Esta acción no se puede deshacer.",
    "es-MX": "Esta acción no se puede deshacer.",
    "en-US": "This action cannot be undone."
  },
  "cancel": {
    "es-AR": "Cancelar",
    "es-MX": "Cancelar",
    "en-US": "Cancel"
  },

  // Admin Photos page
  "adminPhotosMetaTitle": {
    "es-AR": "Gestión de Fotos - Admin",
    "es-MX": "Gestión de Fotos - Admin",
    "en-US": "Photo Management - Admin"
  },
  "reviewModeratedPhotos": {
    "es-AR": "Revisar fotos moderadas",
    "es-MX": "Revisar fotos moderadas",
    "en-US": "Review moderated photos"
  },
  "downloadAlbum": {
    "es-AR": "Descargar álbum",
    "es-MX": "Descargar álbum",
    "en-US": "Download album"
  },
  "preparingZip": {
    "es-AR": "Comprimiendo fotos",
    "es-MX": "Comprimiendo fotos",
    "en-US": "Preparing .zip"
  },
  "downloadZip": {
    "es-AR": "Descargar álbum",
    "es-MX": "Descargar álbum",
    "en-US": "Download .zip"
  },
  "availableUntil": {
    "es-AR": "Disponible hasta el: {date}",
    "es-MX": "Disponible hasta el: {date}",
    "en-US": "Available until: {date}"
  },
  "downloadModalTitle": {
    "es-AR": "Descargar álbum",
    "es-MX": "Descargar álbum",
    "en-US": "Download album"
  },
  "downloadModalSubtitle": {
    "es-AR": "Esto generará un archivo comprimido con todas las fotos en calidad HD.",
    "es-MX": "Esto generará un archivo comprimido con todas las fotos en calidad HD.",
    "en-US": "This will generate a compressed file with all photos in HD quality."
  },
  "fileReadyTitle": {
    "es-AR": "Archivo listo",
    "es-MX": "Archivo listo",
    "en-US": "File ready"
  },
  "downloadEstimatedTime": {
    "es-AR": "Tardaremos aproximadamente {minutes} minuto{s} en procesar las {photos} fotos.",
    "es-MX": "Tardaremos aproximadamente {minutes} minuto{s} en procesar las {photos} fotos.",
    "en-US": "It will take approximately {minutes} minute{s} to process the {photos} photos."
  },
  "beginDownload": {
    "es-AR": "Comenzar Descarga",
    "es-MX": "Comenzar Descarga",
    "en-US": "Start download"
  },
  "download": {
    "es-AR": "Descargar",
    "es-MX": "Descargar",
    "en-US": "Download"
  },
  "downloadFinished": {
    "es-AR": "Descarga finalizada",
    "es-MX": "Descarga finalizada",
    "en-US": "Download complete"
  },
  "fileAvailableUntil": {
    "es-AR": "El archivo estará disponible hasta el {date}",
    "es-MX": "El archivo estará disponible hasta el {date}",
    "en-US": "The file will be available until {date}"
  },
  "downloadCanCloseModalHint": {
    "es-AR": "Podés cerrar esta ventana y volver luego",
    "es-MX": "Podés cerrar esta ventana y volver luego",
    "en-US": "You can close this window and come back later"
  },
  "downloadEstimatedIntro": {
    "es-AR": "Tardaremos aproximadamente",
    "es-MX": "Tardaremos aproximadamente",
    "en-US": "It will take approximately"
  },
  "downloadEstimatedDetails": {
    "es-AR": "{minutes} minuto{s} en procesar las {photos} fotos.",
    "es-MX": "{minutes} minuto{s} en procesar las {photos} fotos.",
    "en-US": "{minutes} minute{s} to process the {photos} photos."
  },

  "albumReadyToDownload": {
    "es-AR": "El álbum está listo para descargar",
    "es-MX": "El álbum está listo para descargar",
    "en-US": "Album is ready to download"
  },
  "couldNotPrepareAlbumDownload": {
    "es-AR": "No se pudo preparar la descarga del álbum",
    "es-MX": "No se pudo preparar la descarga del álbum",
    "en-US": "Could not prepare album download"
  },
  "albumDownloadReady": {
    "es-AR": "Archivo listo para descargar.",
    "es-MX": "Archivo listo para descargar.",
    "en-US": "The file is ready."
  },
  "mostVotedFirst": {
    "es-AR": "Con más likes arriba",
    "es-MX": "Con más likes arriba",
    "en-US": "Most liked first"
  },
  "mostCommentedFirst": {
    "es-AR": "Más comentadas arriba",
    "es-MX": "Más comentadas arriba",
    "en-US": "Most commented first"
  },
  "flaggedFirst": {
    "es-AR": "Ocultas arriba",
    "es-MX": "Ocultas arriba",
    "en-US": "Flagged first"
  },
  "delete": {
    "es-AR": "Eliminar",
    "es-MX": "Eliminar",
    "en-US": "Delete"
  },
  "noPhotosFound": {
    "es-AR": "Aún no hay fotos",
    "es-MX": "Aún no hay fotos",
    "en-US": "No photos yet"
  },
  "loadingPhotos": {
    "es-AR": "Cargando fotos...",
    "es-MX": "Cargando fotos...",
    "en-US": "Loading photos..."
  },
  "photoTableHeader": {
    "es-AR": "Foto",
    "es-MX": "Foto",
    "en-US": "Photo"
  },
  "userTableHeader": {
    "es-AR": "Usuario",
    "es-MX": "Usuario",
    "en-US": "User"
  },
  "votesTableHeader": {
    "es-AR": "Likes",
    "es-MX": "Likes",
    "en-US": "Likes"
  },
  "uploadedTableHeader": {
    "es-AR": "Subida",
    "es-MX": "Subida",
    "en-US": "Uploaded"
  },
  "actionsTableHeader": {
    "es-AR": "Acciones",
    "es-MX": "Acciones",
    "en-US": "Actions"
  },
  "moderatedLabel": {
    "es-AR": "Mostrar",
    "es-MX": "Mostrar",
    "en-US": "Show"
  },
  "moderateLabel": {
    "es-AR": "Ocultar",
    "es-MX": "Ocultar",
    "en-US": "Hide"
  },
  "success": {
    "es-AR": "Éxito",
    "es-MX": "Éxito",
    "en-US": "Success"
  },
  "photosDeletedSuccessfully": {
    "es-AR": "Se eliminaron {count} foto{s} correctamente",
    "es-MX": "Se eliminaron {count} foto{s} correctamente",
    "en-US": "Deleted {count} photo{s} successfully"
  },
  "photoDeletedSuccessfully": {
    "es-AR": "Foto eliminada correctamente",
    "es-MX": "Foto eliminada correctamente",
    "en-US": "Photo deleted successfully"
  },
  "failedToLoadPhotos": {
    "es-AR": "No se pudieron cargar las fotos",
    "es-MX": "No se pudieron cargar las fotos",
    "en-US": "Failed to load photos"
  },
  "couldNotDeletePhoto": {
    "es-AR": "No se pudo eliminar la foto",
    "es-MX": "No se pudo eliminar la foto",
    "en-US": "Could not delete the photo"
  },
  "photoFlaggedForModeration": {
    "es-AR": "Foto oculta temporalmente",
    "es-MX": "Foto oculta temporalmente",
    "en-US": "Photo flagged for moderation"
  },
  "photoUnflaggedSuccessfully": {
    "es-AR": "Foto publicada correctamente",
    "es-MX": "Foto publicada correctamente",
    "en-US": "Photo unflagged successfully"
  },
  "couldNotChangeModerationStatus": {
    "es-AR": "No se pudo cambiar el estado de moderación",
    "es-MX": "No se pudo cambiar el estado de moderación",
    "en-US": "Could not change moderation status"
  },
  "mediaAlt": {
    "es-AR": "Media",
    "es-MX": "Media",
    "en-US": "Media"
  },
  "enlargedImageAlt": {
    "es-AR": "Imagen ampliada",
    "es-MX": "Imagen ampliada",
    "en-US": "Enlarged image"
  },

  // Admin Config page
  "adminConfigMetaTitle": {
    "es-AR": "Configuración - Admin",
    "es-MX": "Configuración - Admin",
    "en-US": "Settings - Admin"
  },
  "settingsTitle": {
    "es-AR": "Configuraciones",
    "es-MX": "Configuraciones",
    "en-US": "Settings"
  },
  "configAreaTitle": {
    "es-AR": "Área de Configuración",
    "es-MX": "Área de Configuración",
    "en-US": "Configuration Area"
  },
  "albumCustomization": {
    "es-AR": "Personalización del Álbum",
    "es-MX": "Personalización del Álbum",
    "en-US": "Album Customization"
  },
  "albumInfoTitle": {
    "es-AR": "Info del Álbum",
    "es-MX": "Info del Álbum",
    "en-US": "Album Info"
  },
  "nameLabel": {
    "es-AR": "Nombre",
    "es-MX": "Nombre",
    "en-US": "Name"
  },
  "statusLabel": {
    "es-AR": "Estado",
    "es-MX": "Estado",
    "en-US": "Status"
  },
  "active": {
    "es-AR": "Activo",
    "es-MX": "Activo",
    "en-US": "Active"
  },
  "inactive": {
    "es-AR": "Inactivo",
    "es-MX": "Inactivo",
    "en-US": "Inactive"
  },
  "idLabel": {
    "es-AR": "ID",
    "es-MX": "ID",
    "en-US": "ID"
  },
  "edit": {
    "es-AR": "Editar",
    "es-MX": "Editar",
    "en-US": "Edit"
  },
  "customTheme": {
    "es-AR": "Tema personalizado",
    "es-MX": "Tema personalizado",
    "en-US": "Custom theme"
  },
  "presetTheme": {
    "es-AR": "Tema predefinido",
    "es-MX": "Tema predefinido",
    "en-US": "Preset theme"
  },
  "notConfigured": {
    "es-AR": "No configurado",
    "es-MX": "No configurado",
    "en-US": "Not configured"
  },
  "uploadingImage": {
    "es-AR": "Subiendo imagen...",
    "es-MX": "Subiendo imagen...",
    "en-US": "Uploading image..."
  },
  "previewAlt": {
    "es-AR": "Vista previa",
    "es-MX": "Vista previa",
    "en-US": "Preview"
  },
  "selectedPreviewAlt": {
    "es-AR": "Vista previa seleccionada",
    "es-MX": "Vista previa seleccionada",
    "en-US": "Selected preview"
  },
  "upload": {
    "es-AR": "Subir",
    "es-MX": "Subir",
    "en-US": "Upload"
  },
  "readOnly": {
    "es-AR": "(Solo lectura)",
    "es-MX": "(Solo lectura)",
    "en-US": "(Read only)"
  },
  "designTitle": {
    "es-AR": "Diseño",
    "es-MX": "Diseño",
    "en-US": "Design"
  },
  "designDescription": {
    "es-AR": "Colores, tipografías, portada y logo",
    "es-MX": "Colores, tipografías, portada y logo",
    "en-US": "Colors, fonts, cover and logo"
  },
  "noThemeSettingsAvailable": {
    "es-AR": "No hay configuraciones de tema disponibles",
    "es-MX": "No hay configuraciones de tema disponibles",
    "en-US": "No theme settings available"
  },
  "noImageSettingsAvailable": {
    "es-AR": "No hay configuraciones de imagen disponibles",
    "es-MX": "No hay configuraciones de imagen disponibles",
    "en-US": "No image settings available"
  },
  "textsTitle": {
    "es-AR": "Textos",
    "es-MX": "Textos",
    "en-US": "Texts"
  },
  "textsDescription": {
    "es-AR": "Títulos y descripciones",
    "es-MX": "Títulos y descripciones",
    "en-US": "Titles and descriptions"
  },
  "noTextSettingsAvailable": {
    "es-AR": "No hay configuraciones de texto disponibles",
    "es-MX": "No hay configuraciones de texto disponibles",
    "en-US": "No text settings available"
  },
  "metaTitle": {
    "es-AR": "Metadatos",
    "es-MX": "Metadatos",
    "en-US": "Metadata"
  },
  "metaSettingsDescription": {
    "es-AR": "Configuraciones de etiquetas <meta>",
    "es-MX": "Configuraciones de etiquetas <meta>",
    "en-US": "Meta tag settings"
  },
  "metaShareUsageNote": {
    "es-AR": "Se usan cuando se comparte la URL del álbum por WhatsApp, Instagram, etc...",
    "es-MX": "Se usan cuando se comparte la URL del álbum por WhatsApp, Instagram, etc...",
    "en-US": "Used when sharing the album URL via WhatsApp, Instagram, etc."
  },
  "metaBrowserNote": {
    "es-AR": "Esto modifica el título y el favicon de la pestaña del navegador.",
    "es-MX": "Esto modifica el título y el favicon de la pestaña del navegador.",
    "en-US": "This changes the browser tab title and favicon."
  },
  "noMetaSettingsAvailable": {
    "es-AR": "No hay configuraciones de metadatos disponibles",
    "es-MX": "No hay configuraciones de metadatos disponibles",
    "en-US": "No metadata settings available"
  },
  "shareFrameTitle": {
    "es-AR": "Al Compartir una Foto",
    "es-MX": "Al Compartir una Foto",
    "en-US": "When Sharing a Photo"
  },
  "shareFrameDescription": {
    "es-AR": "Marco y metadatos que se usan cuando se comparte una foto desde el álbum por WhatsApp, Instagram, etc...",
    "es-MX": "Marco y metadatos que se usan cuando se comparte una foto desde el álbum por WhatsApp, Instagram, etc...",
    "en-US": "Frame and metadata used when sharing a photo from the album via WhatsApp, Instagram, etc."
  },
  "noShareSettingsAvailable": {
    "es-AR": "No hay configuración de marco para compartir disponible",
    "es-MX": "No hay configuración de marco para compartir disponible",
    "en-US": "No share frame settings available"
  },
  "miscTitle": {
    "es-AR": "Cositas",
    "es-MX": "Cositas",
    "en-US": "Misc"
  },
  "generalSettingsDescription": {
    "es-AR": "Configuraciones generales",
    "es-MX": "Configuraciones generales",
    "en-US": "General settings"
  },
  "noOtherSettingsAvailable": {
    "es-AR": "No hay otras configuraciones disponibles",
    "es-MX": "No hay otras configuraciones disponibles",
    "en-US": "No other settings available"
  },
  "settingsUpdateErrorDescription": {
    "es-AR": "No se pudo actualizar la configuración. Verifica tus permisos.",
    "es-MX": "No se pudo actualizar la configuración. Verifica tus permisos.",
    "en-US": "Could not update settings. Check your permissions."
  },
  "settingUpdatedTitle": {
    "es-AR": "Configuración actualizada",
    "es-MX": "Configuración actualizada",
    "en-US": "Settings updated"
  },
  "settingUpdatedDescription": {
    "es-AR": "La configuración \"{key}\" se actualizó correctamente.",
    "es-MX": "La configuración \"{key}\" se actualizó correctamente.",
    "en-US": "Setting \"{key}\" updated successfully."
  },
  "imageUploadedTitle": {
    "es-AR": "Imagen cargada",
    "es-MX": "Imagen cargada",
    "en-US": "Image uploaded"
  },
  "imageUploadedDescription": {
    "es-AR": "La imagen se ha subido y guardado correctamente.",
    "es-MX": "La imagen se ha subido y guardado correctamente.",
    "en-US": "The image has been uploaded and saved successfully."
  },
  "imageUploadFailed": {
    "es-AR": "No se pudo subir la imagen. Intenta de nuevo.",
    "es-MX": "No se pudo subir la imagen. Intenta de nuevo.",
    "en-US": "Failed to upload the image. Please try again."
  },

  // Admin Theme page
  "adminThemeMetaTitle": {
    "es-AR": "Gestión de Temas - Admin",
    "es-MX": "Gestión de Temas - Admin",
    "en-US": "Theme Management - Admin"
  },
  "manageThemesTitle": {
    "es-AR": "Gestión de Temas",
    "es-MX": "Gestión de Temas",
    "en-US": "Theme Management"
  },
  "colorsAndTypography": {
    "es-AR": "Colores y Tipografías",
    "es-MX": "Colores y Tipografías",
    "en-US": "Colors and Typography"
  },
  "pendingChangesTitle": {
    "es-AR": "Cambios pendientes",
    "es-MX": "Cambios pendientes",
    "en-US": "Pending changes"
  },
  "pendingChangesDescription": {
    "es-AR": "Tienes cambios sin guardar. La vista previa se actualiza automáticamente.",
    "es-MX": "Tienes cambios sin guardar. La vista previa se actualiza automáticamente.",
    "en-US": "You have unsaved changes. The preview updates automatically."
  },
  "themeConfiguration": {
    "es-AR": "Configuración de Tema",
    "es-MX": "Configuración de Tema",
    "en-US": "Theme Configuration"
  },
  "themeConfigurationDescription": {
    "es-AR": "Personaliza la apariencia de tu álbum eligiendo un tema predefinido o creando uno personalizado.",
    "es-MX": "Personaliza la apariencia de tu álbum eligiendo un tema predefinido o creando uno personalizado.",
    "en-US": "Customize your album appearance by choosing a preset theme or creating a custom one."
  },
  "presetThemes": {
    "es-AR": "Temas Predefinidos",
    "es-MX": "Temas Predefinidos",
    "en-US": "Preset Themes"
  },
  "customizeTheme": {
    "es-AR": "Personalizar Tema",
    "es-MX": "Personalizar Tema",
    "en-US": "Customize Theme"
  },
  "usingCustomTheme": {
    "es-AR": "Usando Tema Personalizado",
    "es-MX": "Usando Tema Personalizado",
    "en-US": "Using Custom Theme"
  },
  "usingLabel": {
    "es-AR": "Usando:",
    "es-MX": "Usando:",
    "en-US": "Using:"
  },
  "previewTitle": {
    "es-AR": "Vista Previa",
    "es-MX": "Vista Previa",
    "en-US": "Preview"
  },
  "themeSavedTitle": {
    "es-AR": "Tema guardado",
    "es-MX": "Tema guardado",
    "en-US": "Theme saved"
  },
  "themeSavedDescription": {
    "es-AR": "La configuración del tema se ha guardado correctamente.",
    "es-MX": "La configuración del tema se ha guardado correctamente.",
    "en-US": "Theme settings have been saved successfully."
  },
  "themeSaveFailedDescription": {
    "es-AR": "No se pudo guardar la configuración del tema.",
    "es-MX": "No se pudo guardar la configuración del tema.",
    "en-US": "Could not save the theme settings."
  },
  "valuesRestoredTitle": {
    "es-AR": "Valores restaurados",
    "es-MX": "Valores restaurados",
    "en-US": "Values restored"
  },
  "valuesRestoredDescription": {
    "es-AR": "Los valores se han restaurado al tema actual aplicado.",
    "es-MX": "Los valores se han restaurado al tema actual aplicado.",
    "en-US": "Values have been restored to the currently applied theme."
  },

  // Ranking component
  "noUsersInRanking": {
    "es-AR": "Aún no hay usuarios en el ranking",
    "es-MX": "Aún no hay usuarios en el ranking",
    "en-US": "There are no users in the leaderboard yet"
  },
  "votedPhotosByUser": {
    "es-AR": "{count} foto{s} likeada{s}",
    "es-MX": "{count} foto{s} likeada{s}",
    "en-US": "{count} photo{s} liked"
  },

  // Live gallery page (LosMasVotados references Ranking only, but include meta)
  "topVotedMetaTitle": {
    "es-AR": "Ranking de Likes",
    "es-MX": "Ranking de Likes",
    "en-US": "Top Liked"
  },

  // ModerationModal
  "pendingApproval": {
    "es-AR": "Pendiente de Aprobación",
    "es-MX": "Pendiente de Aprobación",
    "en-US": "Pending Approval"
  },
  "moderationExplainer": {
    "es-AR": "Estas fotos fueron marcadas para moderación. Están ocultas del álbum hasta ser aprobadas.",
    "es-MX": "Estas fotos fueron marcadas para moderación. Están ocultas del álbum hasta ser aprobadas.",
    "en-US": "These photos were flagged for moderation. They are hidden from the album until approved."
  },
  "approve": {
    "es-AR": "Aprobar",
    "es-MX": "Aprobar",
    "en-US": "Approve"
  },
  "noPendingPhotos": {
    "es-AR": "No hay fotos pendientes de moderación.",
    "es-MX": "No hay fotos pendientes de moderación.",
    "en-US": "No photos pending moderation."
  },

  // User actions component
  "yourProfile": {
    "es-AR": "Tu perfil",
    "es-MX": "Tu perfil",
    "en-US": "Your profile"
  },
  "signOut": {
    "es-AR": "Salir",
    "es-MX": "Salir",
    "en-US": "Sign out"
  },

  // LosMásVotados page
  "leaderboardTitle": {
    "es-AR": "Ranking de Likes",
    "es-MX": "Ranking de Likes",
    "en-US": "Top Liked"
  },

  // Galería en Vivo
  "waitingForNewPhotos": {
    "es-AR": "Esperando nuevas fotos...",
    "es-MX": "Esperando nuevas fotos...",
    "en-US": "Waiting for new photos..."
  },
  "enterKeyTitle": {
    "es-AR": "Ingresa la clave",
    "es-MX": "Ingresa la clave",
    "en-US": "Enter the passcode"
  },
  "accessDenied": {
    "es-AR": "Acceso denegado",
    "es-MX": "Acceso denegado",
    "en-US": "Access denied"
  },

  // Album Resolution page
  "accessAnAlbum": {
    "es-AR": "Acceder a un álbum",
    "es-MX": "Acceder a un álbum",
    "en-US": "Access an album"
  },
  "enterAlbumNamePlaceholder": {
    "es-AR": "Ingresa el nombre del álbum...",
    "es-MX": "Ingresa el nombre del álbum...",
    "en-US": "Enter the album name..."
  },
  "search": {
    "es-AR": "Buscar",
    "es-MX": "Buscar",
    "en-US": "Search"
  },
  "searching": {
    "es-AR": "Buscando...",
    "es-MX": "Buscando...",
    "en-US": "Searching..."
  },
  "errorTitle": {
    "es-AR": "Error",
    "es-MX": "Error",
    "en-US": "Error"
  },
  "enterAlbumName": {
    "es-AR": "Por favor ingresa el nombre del álbum",
    "es-MX": "Por favor ingresa el nombre del álbum",
    "en-US": "Please enter the album name"
  },
  "searchAlbumError": {
    "es-AR": "Error al buscar el álbum",
    "es-MX": "Error al buscar el álbum",
    "en-US": "Error searching the album"
  },
  "albumNotFound": {
    "es-AR": "El álbum no existe",
    "es-MX": "El álbum no existe",
    "en-US": "The album does not exist"
  },
  "unexpectedSearchError": {
    "es-AR": "Error inesperado al buscar el álbum",
    "es-MX": "Error inesperado al buscar el álbum",
    "en-US": "Unexpected error searching the album"
  },
  "screenContentTitle": {
    "es-AR": "Contenido para Pantallas",
    "es-MX": "Contenido para Pantallas",
    "en-US": "Display Content"
  },
  "screenContentDescription": {
    "es-AR": "Copiá y enviá estos links a quien se encarga de operar las pantallas o proyectores del evento.",
    "es-MX": "Copia y envía estos links a quien se encarga de operar las pantallas o proyectores del evento.",
    "en-US": "Send the following link to the person in charge of operating the event screens. "
  },
  "screenContentDescriptionLiveGallery": {
    "es-AR": "Pase automático de todas las fotos. Si el Libro de Visitas está habilitado, se intercalan mensajes y fotos.",
    "es-MX": "Pase automático de todas las fotos. Si el Libro de Visitas está habilitado, se intercalan mensajes y fotos.",
    "en-US": "Live slideshow "
  },
  "screenContentDescriptionRanking": {
    "es-AR": "Un Top 10 de los usuarios con más likes a través de sus fotos.",
    "es-MX": "Un Top 10 de los usuarios con más likes a través de sus fotos.",
    "en-US": "Top 10 ranking "
  },
  "keyLabel": {
    "es-AR": "Clave de acceso",
    "es-MX": "Clave de acceso",
    "en-US": "Passcode"
  },
  "copyPublicLink": {
    "es-AR": "Copiar link",
    "es-MX": "Copiar link",
    "en-US": "Copy link"
  },
  "successMessageKey_copyLink": {
    "es-AR": "Link copiado con éxito",
    "es-MX": "Link copiado con éxito",
    "en-US": "The link is now in your clipboard"
  },
  "successMessageKey_copyKey": {
    "es-AR": "Clave copiada con éxito",
    "es-MX": "Clave copiada con éxito",
    "en-US": "The passcode is now in your clipboard"
  }
};

// Merge with existing translations
Object.assign(translations, additionalTranslations);

export const DEFAULT_LANGUAGE = "es-AR";
export const SUPPORTED_LANGUAGES = ["es-AR", "es-MX", "en-US"] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

// Admin Config language UI labels
translations['languageLabel'] = {
  'es-AR': 'Idioma',
  'es-MX': 'Idioma',
  'en-US': 'Language',
};
translations['save'] = {
  'es-AR': 'Aplicar',
  'es-MX': 'Aplicar',
  'en-US': 'Apply',
};

// Generic actions
translations['apply'] = {
  'es-AR': 'Aplicar',
  'es-MX': 'Aplicar',
  'en-US': 'Apply',
};
translations['clear'] = {
  'es-AR': 'Limpiar',
  'es-MX': 'Limpiar',
  'en-US': 'Clear',
};

// Comments translations
translations['comments'] = {
  'es-AR': 'Comentarios',
  'es-MX': 'Comentarios',
  'en-US': 'Comments',
};
translations['comment'] = {
  'es-AR': 'comentario',
  'es-MX': 'comentario',
  'en-US': 'comment',
};
translations['addComment'] = {
  'es-AR': 'Agregar un comentario...',
  'es-MX': 'Agregar un comentario...',
  'en-US': 'Add a comment...',
};
translations['noComments'] = {
  'es-AR': 'No hay comentarios aún',
  'es-MX': 'No hay comentarios aún',
  'en-US': 'No comments yet',
};
translations['beFirstToComment'] = {
  'es-AR': 'Rompé el hielo...',
  'es-MX': 'Rompe el hielo...',
  'en-US': 'Be the first to comment',
};
translations['edit'] = {
  'es-AR': 'Editar',
  'es-MX': 'Editar',
  'en-US': 'Edit',
};
translations['delete'] = {
  'es-AR': 'Eliminar',
  'es-MX': 'Eliminar',
  'en-US': 'Delete',
};
translations['cancel'] = {
  'es-AR': 'Cancelar',
  'es-MX': 'Cancelar',
  'en-US': 'Cancel',
};
translations['uploadedByAll'] = {
  'es-AR': 'Subidas por todos',
  'es-MX': 'Subidas por todos',
  'en-US': 'Uploaded by all',
};
translations['oneUser'] = {
  'es-AR': '1 usuario',
  'es-MX': '1 usuario',
  'en-US': '1 user',
};
translations['users'] = {
  'es-AR': 'usuarios',
  'es-MX': 'usuarios',
  'en-US': 'users',
};
translations['userNotFound'] = {
  'es-AR': 'Usuario no encontrado',
  'es-MX': 'Usuario no encontrado',
  'en-US': 'User not found',
};
translations['hideMinePhotos'] = {
  'es-AR': 'Ocultar mías',
  'es-MX': 'Ocultar mías',
  'en-US': 'Hide mine',
};
translations['hideMinePhotosActive'] = {
  'es-AR': 'Ocultando mías',
  'es-MX': 'Ocultando mías',
  'en-US': 'Hiding mine',
};
translations['uploadPageMetaTitle'] = {
  'es-AR': 'Subir Fotos',
  'es-MX': 'Subir Fotos',
  'en-US': 'Upload Photos',
};
translations['uploadPageHeaderTitle'] = {
  'es-AR': 'Subir fotos',
  'es-MX': 'Subir fotos',
  'en-US': 'Upload photos',
};
translations['shareYourPhotos'] = {
  'es-AR': 'Compartí tus fotos',
  'es-MX': 'Comparte tus fotos',
  'en-US': 'Share your photos',
};
translations['chooseBestPhotos'] = {
  'es-AR': 'Elige las mejores fotos que tengas',
  'es-MX': 'Elige las mejores fotos que tengas',
  'en-US': 'Choose your best photos',
};
translations['select'] = {
  'es-AR': 'Seleccionar',
  'es-MX': 'Seleccionar',
  'en-US': 'Select',
};
translations['selectMore'] = {
  'es-AR': 'Seleccionar más',
  'es-MX': 'Seleccionar más',
  'en-US': 'Select more',
};
translations['uploading'] = {
  'es-AR': 'Subiendo...',
  'es-MX': 'Subiendo...',
  'en-US': 'Uploading...',
};
translations['uploadCountLabel'] = {
  'es-AR': 'Subir {count} foto{s}',
  'es-MX': 'Subir {count} foto{s}',
  'en-US': 'Upload {count} photo{s}',
};
translations['uploadRuleAuthorCanDelete'] = {
  'es-AR': 'Como autor de tus fotos, podrás borrarlas en cualquier momento.',
  'es-MX': 'Como autor de tus fotos, podrás borrarlas en cualquier momento.',
  'en-US': 'As the author of your photos, you can delete them at any time.',
};
translations['uploadRuleModeration'] = {
  'es-AR': 'Tu material está sujeto a moderación. Cualquier conducta inapropiada resultará en tu usuario siendo expulsado de la aplicación.',
  'es-MX': 'Tu material está sujeto a moderación. Cualquier conducta inapropiada resultará en tu usuario siendo expulsado de la aplicación.',
  'en-US': 'Your content is subject to moderation. Inappropriate behavior may result in account removal.',
};
translations['close'] = {
  'es-AR': 'Cerrar',
  'es-MX': 'Cerrar',
  'en-US': 'Close',
};
translations['uploadSuccessTitle'] = {
  'es-AR': '¡Listo, {name}!',
  'es-MX': '¡Listo, {name}!',
  'en-US': 'Done, {name}!',
};
translations['uploadSuccessSubtitle'] = {
  'es-AR': 'Ya publicamos tus fotos',
  'es-MX': 'Ya publicamos tus fotos',
  'en-US': 'Your photos are now published',
};
translations['viewAlbumAction'] = {
  'es-AR': 'Ver álbum',
  'es-MX': 'Ver álbum',
  'en-US': 'View album',
};
translations['uploadMore'] = {
  'es-AR': 'Subir más',
  'es-MX': 'Subir más',
  'en-US': 'Upload more',
};
translations['uploadErrorSelectAtLeastOne'] = {
  'es-AR': 'Por favor selecciona al menos un archivo',
  'es-MX': 'Por favor selecciona al menos un archivo',
  'en-US': 'Please select at least one file',
};
translations['uploadErrorSignInRequired'] = {
  'es-AR': 'Por favor inicia sesión para subir archivos',
  'es-MX': 'Por favor inicia sesión para subir archivos',
  'en-US': 'Please sign in to upload files',
};
translations['uploadErrorSuspended'] = {
  'es-AR': 'Tu cuenta ha sido suspendida y no puedes subir archivos',
  'es-MX': 'Tu cuenta ha sido suspendida y no puedes subir archivos',
  'en-US': 'Your account has been suspended and cannot upload files',
};
translations['uploadErrorGeneric'] = {
  'es-AR': 'Hubo un problema al subir tus fotos. Intenta de nuevo.',
  'es-MX': 'Hubo un problema al subir tus fotos. Intenta de nuevo.',
  'en-US': 'There was a problem uploading your photos. Please try again.',
};
translations['uploadErrorOnlyImagesNoGif'] = {
  'es-AR': 'Solo se permiten imágenes (JPG, PNG, WEBP, AVIF, HEIC, HEIF). No se permiten videos ni GIF.',
  'es-MX': 'Solo se permiten imágenes (JPG, PNG, WEBP, AVIF, HEIC, HEIF). No se permiten videos ni GIF.',
  'en-US': 'Only images are allowed (JPG, PNG, WEBP, AVIF, HEIC, HEIF). Videos and GIFs are not allowed.',
};
translations['uploadErrorSomeFilesRejected'] = {
  'es-AR': 'Se descartaron {count} archivo{s}.',
  'es-MX': 'Se descartaron {count} archivo{s}.',
  'en-US': '{count} file{s} were rejected.',
};
translations['uploadNameFallbackWow'] = {
  'es-AR': 'Wow',
  'es-MX': 'Wow',
  'en-US': 'Wow',
};
translations['uploadNameFallbackTip'] = {
  'es-AR': 'Te digo algo',
  'es-MX': 'Te digo algo',
  'en-US': 'Quick note',
};
translations['uploadProgressOptimizing'] = {
  'es-AR': 'Optimizando {count} foto{s}...',
  'es-MX': 'Optimizando {count} foto{s}...',
  'en-US': 'Optimizing {count} photo{s}...',
};
translations['uploadProgressPositioning'] = {
  'es-AR': 'Posicionando {count} foto{s} en el álbum...',
  'es-MX': 'Posicionando {count} foto{s} en el álbum...',
  'en-US': 'Placing {count} photo{s} in the album...',
};
translations['uploadProgressAnalyzing'] = {
  'es-AR': '{name}, estamos analizando cada detalle de tus fotos. ¡Qué buenas tomas!',
  'es-MX': '{name}, estamos analizando cada detalle de tus fotos. ¡Qué buenas tomas!',
  'en-US': '{name}, we are analyzing every detail of your photos. Great shots!',
};
translations['uploadProgressProcessing'] = {
  'es-AR': 'Procesando {count} foto{s}...',
  'es-MX': 'Procesando {count} foto{s}...',
  'en-US': 'Processing {count} photo{s}...',
};
translations['uploadProgressAlmostThere'] = {
  'es-AR': 'Ya casi {name}, este material tiene que llegar seguro a los servidores ☁️',
  'es-MX': 'Ya casi {name}, este material tiene que llegar seguro a los servidores ☁️',
  'en-US': 'Almost there {name}, this content is being safely delivered to our servers ☁️',
};
translations['uploadProgressConnecting'] = {
  'es-AR': 'Conectando {count} foto{s} en el sistema...',
  'es-MX': 'Conectando {count} foto{s} en el sistema...',
  'en-US': 'Connecting {count} photo{s} in the system...',
};
translations['uploadProgressGold'] = {
  'es-AR': '{name}, cada foto tuya vale oro... por eso las cuidamos tanto en el proceso.',
  'es-MX': '{name}, cada foto tuya vale oro... por eso las cuidamos tanto en el proceso.',
  'en-US': '{name}, every photo is precious... that is why we handle them carefully.',
};
translations['uploadProgressExcitement'] = {
  'es-AR': 'Ya casi listo {name}... ¡qué emoción ver estas fotos en el álbum!',
  'es-MX': 'Ya casi listo {name}... ¡qué emoción ver estas fotos en el álbum!',
  'en-US': 'Almost done {name}... exciting to see these photos in the album!',
};
translations['uploadProgressFinishing'] = {
  'es-AR': 'Terminando... ¡estas {count} foto{s} van a ser la envidia del álbum!',
  'es-MX': 'Terminando... ¡estas {count} foto{s} van a ser la envidia del álbum!',
  'en-US': 'Finishing... these {count} photo{s} will be the stars of the album!',
};
translations['selectPhotos'] = {
  'es-AR': 'Seleccionar…',
  'es-MX': 'Seleccionar…',
  'en-US': 'Select…',
};
translations['selectAll'] = {
  'es-AR': 'Seleccionar todo',
  'es-MX': 'Seleccionar todo',
  'en-US': 'Select all',
};
translations['informationLabel'] = {
  'es-AR': 'Información',
  'es-MX': 'Información',
  'en-US': 'Information',
};
translations['selectedCount'] = {
  'es-AR': '{count} seleccionada{s}',
  'es-MX': '{count} seleccionada{s}',
  'en-US': '{count} selected item{s}',
};
translations['actions'] = {
  'es-AR': 'Acciones',
  'es-MX': 'Acciones',
  'en-US': 'Actions',
};
translations['hide'] = {
  'es-AR': 'Ocultar',
  'es-MX': 'Ocultar',
  'en-US': 'Hide',
};
translations['show'] = {
  'es-AR': 'Mostrar',
  'es-MX': 'Mostrar',
  'en-US': 'Show',
};
translations['deleteShort'] = {
  'es-AR': 'Borrar',
  'es-MX': 'Borrar',
  'en-US': 'Delete',
};
translations['loadMore'] = {
  'es-AR': 'Cargar más',
  'es-MX': 'Cargar más',
  'en-US': 'Load more',
};
translations['loadingComments'] = {
  'es-AR': 'Cargando comentarios...',
  'es-MX': 'Cargando comentarios...',
  'en-US': 'Loading comments...',
};
translations['votes'] = {
  'es-AR': 'Likes',
  'es-MX': 'Likes',
  'en-US': 'Likes',
};
translations['albumNavLabel'] = {
  'es-AR': 'Álbum',
  'es-MX': 'Álbum',
  'en-US': 'Album',
};
translations['noVotesYet'] = {
  'es-AR': 'Sin likes áun',
  'es-MX': 'Sin likes áun',
  'en-US': 'No likes yet',
};

translations['send'] = {
  'es-AR': 'Enviar',
  'es-MX': 'Enviar',
  'en-US': 'Send',
};

translations['notPubliclyVisible'] = {
  'es-AR': 'No visible públicamente',
  'es-MX': 'No visible públicamente',
  'en-US': 'Not publicly visible',
};

// Side panel banners
translations['flaggedHiddenUserBanner'] = {
  'es-AR': 'No visible públicamente.',
  'es-MX': 'No visible públicamente.',
  'en-US': 'Not publicly visible',
};

// Guestbook (Mensajes) component
translations['guestbookTitle'] = {
  'es-AR': 'Libro de Visitas',
  'es-MX': 'Libro de Visitas',
  'en-US': 'Guestbook',
};
translations['writeMessage'] = {
  'es-AR': 'Escribir mensaje',
  'es-MX': 'Escribir mensaje',
  'en-US': 'Write message',
};
translations['editMessage'] = {
  'es-AR': 'Editar mensaje',
  'es-MX': 'Editar mensaje',
  'en-US': 'Edit message',
};
translations['writeMessagePlaceholder'] = {
  'es-AR': 'Escribí tu mensaje acá... ✨',
  'es-MX': 'Escribe tu mensaje aquí... ✨',
  'en-US': 'Write your message here... ✨',
};
translations['characterCount'] = {
  'es-AR': '{count} / {limit}',
  'es-MX': '{count} / {limit}',
  'en-US': '{count} / {limit}',
};
translations['charactersRemaining'] = {
  'es-AR': '{remaining} caracteres restantes',
  'es-MX': '{remaining} caracteres restantes',
  'en-US': '{remaining} characters remaining',
};
translations['sendMessage'] = {
  'es-AR': 'Enviar',
  'es-MX': 'Enviar',
  'en-US': 'Send',
};
translations['updateMessage'] = {
  'es-AR': 'Actualizar',
  'es-MX': 'Actualizar',
  'en-US': 'Update',
};
translations['savingMessage'] = {
  'es-AR': 'Guardando...',
  'es-MX': 'Guardando...',
  'en-US': 'Saving...',
};
translations['noMessagesYet'] = {
  'es-AR': 'No hay mensajes aún. ¡Sé el primero en escribir uno!',
  'es-MX': 'No hay mensajes aún. ¡Sé el primero en escribir uno!',
  'en-US': 'No messages yet. Be the first to write one!',
};
translations['messageSaveError'] = {
  'es-AR': 'No se pudo guardar el mensaje',
  'es-MX': 'No se pudo guardar el mensaje',
  'en-US': 'Could not save the message',
};
translations['messageDeleteError'] = {
  'es-AR': 'No se pudo eliminar el mensaje',
  'es-MX': 'No se pudo eliminar el mensaje',
  'en-US': 'Could not delete the message',
};
translations['editTooltip'] = {
  'es-AR': 'Editar',
  'es-MX': 'Editar',
  'en-US': 'Edit',
};
translations['deleteTooltip'] = {
  'es-AR': 'Eliminar',
  'es-MX': 'Eliminar',
  'en-US': 'Delete',
};
